import Marquee from "react-fast-marquee";

export const EditorialMarquee = () => {
  const items = ["APEXLINK LOGISTICS", "MOVING THE WORLD", "FTL · LTL · INTERMODAL", "24/7 DISPATCH", "48 STATES"];
  return (
    <div className="border-y border-white/10 bg-ink py-8" data-testid="marquee">
      <Marquee speed={40} gradient={false} autoFill>
        {items.map((t, i) => (
          <span key={i} className="mx-8 flex items-center gap-8">
            <span className="stroke-text font-display text-5xl font-bold uppercase md:text-7xl">{t}</span>
            <span className="text-3xl text-neon">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};
